<template>
  <div class="incentive-records">
    <div class="points-record">
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <!-- 积分兑换与变动记录 -->
          <div class="title-text">{{ $t('shared.creditTransactionHistory') }}</div>
        </div>
      </div>
      <div class="record-info" v-if="employeeList.length > 0">
        <div class="incentive-item" v-for="(subItem, subIndex) in employeeList" :key="subIndex">
          <div class="item-left">
            <div class="user-info">
              <span class="user-name txt-ellipsis">{{ subItem.nickname }}</span>
              <span class="user-type txt-ellipsis" :style="{ 'color': subItem.jobColor, 'border': `1px solid ${subItem.jobColor}` }">{{ subItem.job }}</span>
            </div>
            <div class="phone txt-ellipsis">{{ $t('shared.point') }}: {{ subItem.integral }}</div>
          </div>
          <div class="item-right">
            <img class="icon-img" src="@/assets/images/gift.png" alt="" @click="toUrl(`/pointsExchange?employeeId=${subItem.id}&customerId=${customerId}`)">
            <img class="icon-img" src="@/assets/images/record.png" alt="" @click="toUrl(`/pointsDetail?employeeId=${subItem.id}&customerId=${customerId}`)">
          </div>
        </div>
      </div>
      <van-empty v-else :description="$t('tips.noData')" />
    </div>
    <div class="product-record">
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <!-- 产品绑定记录 -->
          <div class="title-text">{{ $t('shared.productBindingRecords') }}</div>
        </div>
      </div>
      <div class="record-info" v-if="productRecordList.length > 0">
        <div class="incentive-item" v-for="(subItem, subIndex) in productRecordList" :key="subIndex">
          <div class="item-left">
            <div class="user-info">
              <span class="user-name txt-ellipsis">{{ subItem.nickname }}</span>
              <span class="user-type txt-ellipsis" :style="{ 'color': subItem.jobColor, 'border': `1px solid ${subItem.jobColor}` }">{{ subItem.job }}</span>
            </div>
            <div class="name-num txt-ellipsis">{{ subItem.detailName }} <span v-if="subItem.orderType !== 3"><span class="quantity">{{ subItem.totalQuantity }}</span> {{ $t('form.pcs') }}</span></div>
            <div class="time txt-ellipsis">{{ $t('shared.filter.time') }}：{{ subItem.localCreateTime }}</div>
          </div>
          <div class="item-right">
            {{ [0, 3].includes(subItem.orderType) ? '+' : subItem.orderType === 1 ? '-' : '' }}{{subItem.totalIntegral}}
          </div>
        </div>
      </div>
      <van-pagination v-if="productRecordList.length > 0" class="pagination-content" v-model="paginationData.page" :total-items="paginationData.totalRow" :show-page-size="3" items-per-page="10" force-ellipses @change="(page) => handlePagination(page, productIndex)">
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
      <van-empty v-else :description="$t('tips.noData')" />
    </div>
  </div>
</template>

<script>
import { arsActivityOrderAppListPageApi } from '@/api/home'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  props: {
    customerId: {
      type: String,
      default: ''
    },
    employeeList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      productRecordList: [],
      paginationData: {
        page: 1,
        limit: 5,
        totalRow: 0
      }
    }
  },
  mounted () {
    // this.getProductRecord()
  },
  watch: {
    customerId: {
      handler (val) {
        if (val) {
          this.getProductRecord()
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  methods: {
    getProductRecord () {
      const data = {
        customerId: this.customerId,
        page: this.paginationData.page,
        limit: this.paginationData.limit,
        orderTypeList: [0, 2, 3],
        statusList: [10]
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsActivityOrderAppListPageApi(data).then(res => {
        Toast.clear()
        res.data.list.forEach((subItem) => {
          this.globalData.customerJob.find((paramsItem) => {
            if (subItem.job === paramsItem.label && paramsItem.value) {
              subItem.jobColor = JSON.parse(paramsItem.value).color
              return paramsItem
            }
          })
        })
        this.productRecordList = res.data.list
        this.paginationData.totalRow = Number(res.data.totalRow)
      })
    },
    handlePagination (page) {
      this.paginationData.page = page
      this.getProductRecord()
    },
    toUrl (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.incentive-records {
  flex: 1;
  .points-record {
    padding-bottom: 20px;
  }
  // .points-record,
  // .product-record {
  //   height: 50%;
  //   border: 1px solid;
  //   overflow-y: auto;
  // }
  .info {
    .header-title {
      display: flex;
      align-items: center;
      .blue-bar {
        width: 5px;
        height: 16px;
        background-color: #307bff;
        margin-right: 5px;
      }
      .title-text {
        font-weight: bold;
        font-size: 14px;
        color: #307bff;
      }
    }
    .item-title {
      margin-bottom: 10px;
    }
  }
  .record-info {
    padding: 10px;
    .incentive-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(210, 220, 236, .5);
      padding: 10px 0;
      &:nth-child(1) {
        border-top: 1px solid rgba(210, 220, 236, .5);
      }
      .user-info {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 13px;
        .user-name {
          max-width: 170px;
        }
        .user-type {
          max-width: 85px;
          padding: 2px 5px;
          text-align: center;
          border: 1px solid #307bff;
          color: #307bff;
          margin-left: 5px;
          font-size: 12px;
        }
      }
      .phone,
      .name-num {
        font-size: 13px;
        max-width: 260px;
      }
      .name-num {
        margin-bottom: 8px;
        .quantity {
          color: #307bff;;
          font-weight: bold;
        }
      }
      .time {
        font-size: 12px;
        color: #aaa;
      }
      .item-right {
        display: flex;
        justify-content: space-between;
        width: 60px;
      }
      .icon-img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .product-record {
    .item-right {
      justify-content: flex-end;
      color: #307bff;
      font-size: 13px;
      font-weight: bold;
    }
  }
  .pagination-content {
    margin: 10px 0;
    justify-content: flex-end;
    /deep/.van-pagination__item {
      flex: none;
      min-width: 26px;
      width: 26px;
      height: 26px;
      margin-right: 10px;
      font-size: 12px;
      background-color: #e8effc;
      border: 1px solid #7f7f7f;
      color: #7f7f7f;
    }
    /deep/.van-pagination__prev,
    /deep/.van-pagination__next {
      width: 26px;
      height: 26px;
    }
    /deep/.van-pagination__item--active {
      border: 1px solid #307bff;
      color: #307bff;
    }
  }
}
</style>
